import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BetLegsStake } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/BetLegsStake';
import { renderBetTypeName } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/betUtils';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { BetHistoryType } from 'src/domains/players/webview/components/Account/betHistoryTab/BetHistoryTab.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UsersState } from 'src/domains/players/state/UsersState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface BetPropsTypes {
    bet: BetHistoryType;
}

export const BetSingleTypeStakeOdd = observer('BetSingleTypeStakeOdd', ({ bet }: BetPropsTypes) => {
    const common = useCommon();
    const usersState = UsersState.get(common);
    const configComponents = ConfigComponents.get(common);
    const languagesState = LanguagesState.get(common);

    return (
        <div>
            {`${renderBetTypeName(bet.type, configComponents.config, languagesState)} ${usersState.money(configComponents.precision.newFromAnything(bet.stakePerLine))} `}
            <I18n
                langKey='bets.bet-history.stake-label'
                defaultText='stake'
            />{' '}
            <BetLegsStake bet={bet} />
        </div>
    );
});
